<template>
  <div id="application-create" class="page-layout__row" style="padding-left: 30px;
padding-right: 30px;
padding-bottom: 30px;">
    <div class="row" :class="{'w-100':!officeId}">
      <div :class="{'w-50':officeId && typeId == APP_TYPE_DEMO ,'col-md-5':officeId && typeId != APP_TYPE_DEMO ,'col-md-6':!officeId}">
        <div class="section" >
          <ApplicationCreateComponent />
        </div>
      </div>
      <div v-if="officeId && typeId != APP_TYPE_DEMO" class="col-md-7 mr-0">
        <CalendarComponent
            :subject-id="officeId ? officeId : null"
            :subject-type="officeId ? 'office' : 'all'"
            :filter-params="{filter:'future'}"
            :calendar-options="{
                            defaultView: 'dayGridMonth',
                            header: {
                                left: 'prevYear,prev,next,nextYear, today',
                                center: 'title',
                                right: 'dayGridMonth,timeGridWeek,timeGridDay'
                            },
                            businessHours:false,
                            eventCreate:false,
                            calendarWeekends: true,
                            tableView: false,
                            allDayDefault: false,
                            editable: false,
                            eventOverlap: true,
                            displayEventEnd: true,
                            droppable: false,
                            windowResizeDelay: 100,
                            eventBackgroundColor:'#d7f0f7'
                         }"
            :active="!!officeId"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ApplicationCreateComponent from './components/ApplicationCreateComponent';
import CalendarComponent from '@/components/CalendarComponent';

export default {
  name: 'CreateApplication',
  components: { CalendarComponent, ApplicationCreateComponent },
  data() {
    return {};
  },
  computed: {
    officeId() {
      return this.$route.query.officeId;
    },
    typeId() {
      return this.$route.query.typeId;
    },
  },
  created() {
    this.setHeadings({
      title: this.getTranslation('addingApplication'),
      toBack: {
        label: this.getTranslation('backToApplicationList'),
        route: { name: 'api.application.getList' },
      },
    });
  },
};
</script>

<style scoped>

</style>
